import React from'react'
import styled from 'styled-components'
import t from '../../data/en'

export const MenuView = styled.div`
  position: fixed;
  display: flex;
  bottom: 0;
  right: 0;
  top: 100vh;
  left: 100%;
  opacity: 0;
  align-items: center;
  z-index: 200;
`

export const Background = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  left: 100%;
  top: 100vh;
  background: #041E42;
  z-index: 100;
`

export const MenuTitle = styled.h3`
  margin-bottom: 2rem;
  font-size: 17px;
  font-weight: 100;
  color: #ffffff;
  text-align: center;
  @media screen and (min-width: 768px) {
    color: #00B0B9;
    text-align: left;
  }
`

export const EventWrapper = styled.div`
  display: block;
  margin-bottom: 3.5rem;
  color: #ffffff;
  font-weight: 100;
  text-align: center;
  @media screen and (min-width: 768px) {
    display: inline-block;
    width: 50%;
    text-align: left;
  }
`

const EventName = styled.p`
  margin: .3rem 0 .8rem;
  font-size: 1.625rem;
  font-weight: 700;
  cursor: pointer;

  @media screen and (min-width: 768px) {
    font-size: 2.25rem;
    margin: .3rem 0 1.5rem;
  }
`

export const BookingLink = styled.a`
  display: inline-block;
  margin-top: .8rem;
  font-size: 20px;
  font-weight: 100;
  color: #ffffff;

  :visited {
    color: #ffffff;
  }

  :hover, :focus {
    color: #f2f2f2f2;
  }

  @media screen and (min-width: 768px) {
    font-size: 2.25rem;
    margin-top: .5rem;
  }
`

const Location = styled.p`
  font-size: 17px;
  font-weight: 100;
`

export const EventView = ({ url, title, location, id, removeActivty }) => (
  <EventWrapper>
    <EventName onClick={() => removeActivty(id)}>{title}</EventName>
    <Location>{location}</Location>
    <BookingLink href={url}>{t.book_trip}</BookingLink>
  </EventWrapper>
)

export const EventsContainerView = styled.div`
  max-width: 920px;
  margin: 0 auto;
  flex-shrink: 0;
  flex-grow: 1;
`
